module.exports = __webpack_public_path__ + "img/img_tool_1.847226d7.jpg";